// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Badge } from "@/shared/components/ui/Badge";
import { useEscapeKey } from "@/shared/hooks/useEscapeKey";
export function RightsPanel({ candidate, jobs, onUpdate, onErase, onBack, dpo }) {
  useEscapeKey(onBack);
  return (
    <div className="min-h-dvh safe-bottom bg-surface-alt">
      <div className="bg-white border-b border-line text-ink-900 px-4 sm:px-6 py-3 sm:py-4 safe-top safe-x flex items-center gap-3">
        <button onClick={onBack} className="text-ink-400 hover:text-ink-900 text-sm shrink-0">← Back</button>
        <span className="font-bold">My Data Rights</span>
        <Badge/>
      </div>
      <div className="max-w-xl mx-auto px-4 sm:px-6 py-6 sm:py-8 safe-x">
        <h1 className="text-xl sm:text-2xl font-black text-ink-900 mb-4">Your Data Rights (DPDPA 2023)</h1>
        <div className="space-y-3">
          <div className="bg-white border border-line rounded-xl p-4"><p className="font-bold text-sm">§11 Right to Access</p><p className="text-xs text-ink-400 mt-1 break-words">Status: {candidate.status} · Job: {jobs.find(j => j.id === candidate.jobId)?.title || "N/A"}</p></div>
          <button onClick={() => { onUpdate({ consent: false, status: "WITHDRAWN" }); }} className="w-full bg-white border border-line rounded-xl p-4 text-left transition-colors hover:border-brand-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"><p className="font-bold text-sm">§6 Withdraw Consent</p></button>
          <button onClick={() => { if (window.confirm("Erase all data?")) onErase(); }} className="w-full bg-white border border-red-100 rounded-xl p-4 text-left transition-colors hover:border-red-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-bad"><p className="font-bold text-sm text-red-600">§12 Right to Erasure</p></button>
        </div>
        <div className="mt-6 text-xs text-ink-400 text-center">Grievance Officer: <b>{(dpo || {}).name || "—"}</b><br/>{(dpo || {}).email || ""}</div>
      </div>
    </div>
  );
}

// ── MAIN APP ─────────────────────────────────────────────────────────────────
